import {
    DetailPage,
    DetailPagePanelConstraint,
    DetailPagePanelIndicator,
    DetailPagePropertyIndicator
} from "../../common/DetailPage";
import {RouteContext} from "../../../RouteContext";
import {
    Button,
    Dialog,
    DialogBody, DialogContent,
    DialogSurface,
    DialogTitle,
    DialogTrigger,
} from "@fluentui/react-components";
import TruncateText from "../../common/TruncateText";
import {PlaceValueObject} from "../../../../model/vo/content/place/PlaceValueObject";
import {PlacePathJointValueObject} from "../../../../model/vo/content/place/PlacePathJointValueObject";
import {PlacePathValueObject} from "../../../../model/vo/content/place/PlacePathValueObject";
import {ListPage} from "../../common/ListPage";
import {PlacePathIO} from "../../../../io/content/place/PlacePathIO";
import {PlaceVisibilityName} from "../../../../constant/Visibility";
import {PlaceIO} from "../../../../io/content/place/PlaceIO";
import {PlaceParticipationValueObject} from "../../../../model/vo/content/place/PlaceParticipationValueObject";
import {PlaceParticipationIO} from "../../../../io/content/place/PlaceParticipationIO";
import {PlacePathJointIO} from "../../../../io/content/place/PlacePathJointIO";

const propertyDetail: DetailPagePropertyIndicator<PlacePathJointValueObject> = {

}

type Panel = DetailPagePanelConstraint | 'Place' | 'Path' | 'Participation'

const panelDescription: Record<Panel, string> = {
    Main: '기본',
    Place: '플레이스',
    Path: '경로',
    Participation: '참여'

}

const panelDetail: DetailPagePanelIndicator<PlacePathJointValueObject, Panel> = {

    Place: (props: RouteContext, item: PlacePathJointValueObject): JSX.Element => <>
        <ListPage
            {...props}
            key={'shopping-detail-list-page-shopping-modification'}
            description={PlaceValueObject.description}
            excluded={new Set<keyof PlaceValueObject>()}
            list={PlaceIO.list}
            count={PlaceIO.count}
            delete={PlaceIO.delete}
            detailHref={item => `/places/${item.id}`}
            editHref={item => `/places/edit/${item.id}`}
            initialSearchConditions={[
                {
                    name: 'id',
                    value: String(item.placeId),
                    condition: 'Equal'
                },
                {
                    name: 'deletedAt',
                    value: '',
                    condition: 'IsNull'
                },
            ]}/>
    </>,

    Path: (props: RouteContext, item: PlacePathJointValueObject): JSX.Element => <>
        <ListPage
            {...props}
            description={PlacePathValueObject.description}
            list={PlacePathIO.list}
            count={PlacePathIO.count}
            postHref={'/admin/places/paths/post'}
            detailHref={item => `/admin/places/paths/${item.id}`}
            itemValue={(item, key) => {
                if(key == 'format'){
                    return <TruncateText text={item[key] || ''} maxLength={20}/>
                }
                else if(key === 'visibility'){
                    return<>
                        <Dialog modalType="non-modal">
                            <DialogTrigger disableButtonEnhancement>
                                <Button>{item.visibility}</Button>
                            </DialogTrigger>
                            <DialogSurface>
                                <DialogBody>
                                    <DialogTitle>보임여부</DialogTitle>
                                    <DialogContent>
                                        {
                                            PlaceVisibilityName.map((name, idx) => {
                                                const isVisible = !!(Number(item.visibility) & (1 << idx));
                                                return (
                                                    <div key={idx} style={isVisible ? { fontWeight: 'bold' } : {}}>
                                                        {name}
                                                    </div>
                                                );
                                            })
                                        }
                                    </DialogContent>
                                </DialogBody>
                            </DialogSurface>
                        </Dialog>
                    </>
                }
                else {
                    return undefined
                }
            }
            }
            initialSearchConditions={[
                {
                    name: 'id',
                    value: String(item.placePathId),
                    condition: 'Equal'
                },
                {
                    name: 'deletedAt',
                    value: '',
                    condition: 'IsNull'
                },
            ]}/>
    </>,

    Participation: (props: RouteContext, item: PlacePathJointValueObject): JSX.Element => <>
        <ListPage
            {...props}
            description={PlaceParticipationValueObject.description}
            list={PlaceParticipationIO.list}
            count={PlaceParticipationIO.count}
            delete={PlaceParticipationIO.delete}
            detailHref={item => `/places/participations/${item.id}`}
            initialSearchConditions={[
                {
                    name: 'placePathJointId',
                    value: String(item.id),
                    condition: 'Equal'
                },
                {
                    name: 'deletedAt',
                    value: '',
                    condition: 'IsNull'
                },
            ]}

        />
    </>
}

export default function Detail(props: RouteContext) {
    return <>
        <DetailPage
            {...props}
            propertyDescription={PlacePathJointValueObject.description}
            propertyDetail={propertyDetail}
            panelDescription={panelDescription}
            panelDetail={panelDetail}
            get={PlacePathJointIO.get} />
    </>
}